import { helper } from '@ember/component/helper';
import UserOtherAccountModel from 'cio/models/user-other-account';

export function byUserString([user]: [UserOtherAccountModel | null]): string {
  let email = user?.email ?? '';
  return `by ${email !== '' ? email : 'Customer.io'}`;
}

export default helper(byUserString);
